import { Navigate } from "react-router-dom";

import { isThalamosAdministrationSessionContext } from "@thalamos/haven-common";

import { useUser } from "../../Context/UserContext.js";
import { createRoute } from "../../routing/createRoute.js";
import { HomePage } from "./HomePage.js";

/**
 * What `/` is, which depends on the session context the session is acting in.
 *
 * Thalamos staff land in the administration area: their home is the directory,
 * and the assessments page has nothing on it for them — they hold no membership
 * at a customer, so it would show an empty list of somebody else's work.
 *
 * A redirect rather than rendering the administration area at `/`, so every
 * administrative page has exactly one address. Rendering it here would give the
 * users listing two — `/` and `/admin/users` — and the search field labels the
 * page from the path, so it would show nothing on one of them. `replace` keeps
 * `/` out of the history, so Back does not bounce through it.
 *
 * The decision is not in `HomePage`, which deliberately knows who someone is
 * and nothing about what they may do — putting a session context branch inside
 * it would make that untrue.
 */
export const HomeRoute = () => {
  const { user } = useUser();

  return isThalamosAdministrationSessionContext(user?.sessionContext) ? (
    <Navigate to={createRoute.adminUsers()} replace />
  ) : (
    <HomePage />
  );
};
